<template>
  <div>
    <loading v-if="status=== 'loading'"/><div
      v-if="author"
      class="v-content-container">
      <author-display
        :author="author.fields"
        :includes="includes"
      />
      <article-list-author :author-id="author.sys.id"/>
    </div>
  </div>
</template>

<style scoped>
.v-content-container {
  width: 900px;
}
</style>

<script>
import { actions } from "vuex-api";
import { mapState } from "vuex";
import AuthorDisplay from "./author";
import ArticleListAuthor from "./article-list-author";

export default {
  name: "Author",
  components: { ArticleListAuthor, AuthorDisplay },
  computed: mapState({
    author(state) {
      return (
        state.vuexApi[`author-${this.$route.params.slug}`].resp &&
        state.vuexApi[`author-${this.$route.params.slug}`].resp.data &&
        state.vuexApi[`author-${this.$route.params.slug}`].resp.data.items[0]
      );
    },
    status(state) {
      return state.vuexApi[`author-${this.$route.params.slug}`].status;
    },
    includes(state) {
      return (
        state.vuexApi[`author-${this.$route.params.slug}`].resp &&
        state.vuexApi[`author-${this.$route.params.slug}`].resp.data.includes
      );
    }
  }),
  created: function() {
    this.$store.dispatch(actions.request, {
      requestConfig: {
        baseURL: "https://cdn.contentful.com",
        headers: {
          Authorization:
            "Bearer a668f1bb4d9f2c93e9f6f4dfa8954ea8a1ae452c1a1cfb354293df81f08895e9"
        }
      },
      method: "GET",
      url: "spaces/uhuxxitrg1zr/entries",
      params: {
        content_type: "author",
        "fields.slug": this.$route.params.slug,
        include: 3
      },
      keyPath: `author-${this.$route.params.slug}` // Will set the namespace where it will be stored in the vuex state
    });
  }
};
</script>

<style scoped>
</style>
